import React, { FC } from "react";
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { FormControl } from "@material-ui/core";
import { InputChangeEvent } from "./types";
import { FilterLabels, FilterName } from "../../../../context/teamQ/reducers/filtersReducer";
import { useTeamQContext } from "../../../../context/teamQContextProvider";

export type selectOptionsType = { id: string; label: string; };
interface Props {
  canHide: boolean;
  filterName: FilterName;
  handleFilter: (event: InputChangeEvent, supressLoad?: boolean) => void;
  handleHide: (name: FilterName) => void;
  disabled?: boolean;
  maxLength?: number;
  minLength?: number;
}

export const TextInput: FC<Props> = ({ canHide, disabled, filterName, handleFilter, handleHide, maxLength, minLength }) => {

  const {
    state: { filters },
  } = useTeamQContext();

  const filter = filters[filterName];

  if (!filter.show) return null;

  return (
    <div className="form-group">
      <label htmlFor={filterName}>{FilterLabels[filterName]}</label>
      <div className="row">
        {canHide &&
          <div
            className="col-2 pl-2 pt-2"
            role="button"
            aria-label={`Hide ${FilterLabels[filterName]} filter`}
          >
            <ClearOutlinedIcon
              onClick={() => handleHide(filterName)}
            />
          </div>}
        <FormControl className={canHide ? "col-9" : "col-11 pl-3"}>
          <input
            type="text"
            id={filterName}
            className="form-control"
            disabled={disabled}
            placeholder={disabled ? "Filter by Team or Group first" : FilterLabels[filterName]}
            name={filterName}
            value={filter.value}
            onChange={(e): void => {
              if (maxLength && e.target.value.length > maxLength) return;
              handleFilter(
                e as InputChangeEvent, 
                minLength && e.target.value.length > 0 && e.target.value.length < minLength ? true : false
              );
            }}
          />
        </FormControl>
      </div>
    </div>
  );
};
